import * as Api from '@ViewModels';
import { useMutation } from '@tanstack/react-query';
import { useUserSession } from '../../models/hooks/appStateHooks';
import { invalidateRegEdSubmissions } from './useRegEdSubmissionsQuery';

/**
 * Renders the compliance PDF for the post's open round. `ComplianceProviderGate` files nothing
 * without one, so a revision that skips this is never actually submitted — and says so to nobody.
 */
export const useRegEdSocialPostRegenerateCompliancePdfMutation = ({
	onError,
	onSuccess,
}: {
	onError?: (error: Api.IOperationResultNoValue) => void;
	onSuccess?: () => void;
} = {}) => {
	const userSession = useUserSession();
	return useMutation({
		mutationFn: ({
			postId,
			impersonationContext,
		}: {
			postId: string;
			impersonationContext?: Api.IImpersonationContext;
		}) =>
			userSession.webServiceHelper.callAsync<void>(
				Api.ImpersonationBroker.composeApiUrl({
					impersonationContext,
					urlPath: `social/post/${encodeURIComponent(postId)}/regenerateCompliancePDF`,
				}),
				'POST',
				null
			),
		onError,
		onSuccess: (_, { postId }) => {
			invalidateRegEdSubmissions(postId);
			onSuccess?.();
		},
	});
};
